/**
 * Map a playable catalog SearchResult onto the existing party queue item
 * shape. Requestable / non-YouTube / invalid results never become queueable.
 */

import {
  parseYoutubeProviderAssetKey,
  youtubeMqThumbnailUrl,
} from '../catalog/youtubeProviderAsset';

export const CATALOG_QUEUE_SOURCE = 'catalog-search';

export function isCatalogResultQueueable(result) {
  if (!result || typeof result !== 'object') return false;
  if (result.playability?.state !== 'playable') return false;
  if (result.actions && result.actions.queue === false) return false;
  return Boolean(parseYoutubeProviderAssetKey(result.providerAssetKey)?.videoId);
}

export function catalogResultToQueueTrack(result) {
  if (!isCatalogResultQueueable(result)) return null;
  const parsed = parseYoutubeProviderAssetKey(result.providerAssetKey);
  const title = typeof result.displayTitle === 'string' ? result.displayTitle : '';
  const thumbnail = typeof result.thumbnail === 'string' && result.thumbnail.trim()
    ? result.thumbnail.trim()
    : youtubeMqThumbnailUrl(parsed.videoId);

  return {
    id: parsed.videoId,
    videoId: parsed.videoId,
    title,
    thumbnail,
    source: CATALOG_QUEUE_SOURCE,
    recordingId: typeof result.recordingId === 'string' ? result.recordingId : null,
    providerAssetKey: result.providerAssetKey,
  };
}

export function dedupeCatalogResults(results) {
  if (!Array.isArray(results)) return [];
  const seen = new Set();
  const deduped = [];
  results.forEach((result) => {
    const recordingId = typeof result?.recordingId === 'string' ? result.recordingId : '';
    if (!recordingId || seen.has(recordingId)) return;
    seen.add(recordingId);
    deduped.push(result);
  });
  return deduped;
}
